import React, { useState } from 'react';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { UserIcon, BellIcon, MoonIcon, SunIcon, GlobeIcon, ShieldIcon, LogOutIcon, CreditCardIcon } from 'lucide-react';
import { userData } from '../utils/mockData';
export function Settings({
  navigateTo
}) {
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState(true);
  const [emailReceipts, setEmailReceipts] = useState(true);
  const [currency, setCurrency] = useState('USD');
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    // In a real app, this would apply the dark mode to the entire app
    // document.documentElement.classList.toggle('dark');
  };
  return <div className="p-4 max-w-md mx-auto" data-id="element-251">
      <h1 className="text-xl font-bold mb-6" data-id="element-252">Settings</h1>
      <div className="space-y-4" data-id="element-253">
        {/* Profile Section */}
        <Card className="mb-4" data-id="element-254">
          <div className="flex items-center mb-4" data-id="element-255">
            <img src={userData.avatar} alt="User avatar" className="w-16 h-16 rounded-full mr-4" data-id="element-256" />
            <div data-id="element-257">
              <h2 className="font-bold text-lg" data-id="element-258">{userData.name}</h2>
              <p className="text-gray-600 text-sm" data-id="element-259">{userData.company}</p>
              <p className="text-blue-600 text-sm mt-1" data-id="element-260">Edit Profile</p>
            </div>
          </div>
          <div className="border-t pt-3" data-id="element-261">
            <p className="text-gray-600 text-sm mb-1" data-id="element-262">Email</p>
            <p data-id="element-263">jamie.thompson@acmeglobal.com</p>
          </div>
        </Card>
        {/* Preferences */}
        <h2 className="font-bold text-lg mb-2" data-id="element-264">Preferences</h2>
        <Card className="mb-4" data-id="element-265">
          <div className="flex items-center justify-between py-2" data-id="element-266">
            <div className="flex items-center" data-id="element-267">
              <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-268">
                <MoonIcon size={18} className="text-blue-600" data-id="element-269" />
              </div>
              <span data-id="element-270">Dark Mode</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-271">
              <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} className="sr-only peer" data-id="element-272" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-273"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2 border-t" data-id="element-274">
            <div className="flex items-center" data-id="element-275">
              <div className="p-2 bg-purple-100 rounded-full mr-3" data-id="element-276">
                <BellIcon size={18} className="text-purple-600" data-id="element-277" />
              </div>
              <span data-id="element-278">Notifications</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-279">
              <input type="checkbox" checked={notifications} onChange={() => setNotifications(!notifications)} className="sr-only peer" data-id="element-280" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-281"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2 border-t" data-id="element-282">
            <div className="flex items-center" data-id="element-283">
              <div className="p-2 bg-green-100 rounded-full mr-3" data-id="element-284">
                <GlobeIcon size={18} className="text-green-600" data-id="element-285" />
              </div>
              <span data-id="element-286">Currency</span>
            </div>
            <select value={currency} onChange={e => setCurrency(e.target.value)} className="border rounded-md px-2 py-1" data-id="element-287">
              <option value="USD" data-id="element-288">USD ($)</option>
              <option value="EUR" data-id="element-289">EUR (€)</option>
              <option value="GBP" data-id="element-290">GBP (£)</option>
              <option value="JPY" data-id="element-291">JPY (¥)</option>
            </select>
          </div>
          <div className="flex items-center justify-between py-2 border-t" data-id="element-292">
            <div className="flex items-center" data-id="element-293">
              <div className="p-2 bg-yellow-100 rounded-full mr-3" data-id="element-294">
                <CreditCardIcon size={18} className="text-yellow-600" data-id="element-295" />
              </div>
              <div data-id="element-296">
                <span data-id="element-297">Email Receipts</span>
                <p className="text-xs text-gray-500" data-id="element-298">
                  Get copies of your receipts via email
                </p>
              </div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-299">
              <input type="checkbox" checked={emailReceipts} onChange={() => setEmailReceipts(!emailReceipts)} className="sr-only peer" data-id="element-300" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-301"></div>
            </label>
          </div>
        </Card>
        {/* Support & Security */}
        <h2 className="font-bold text-lg mb-2" data-id="element-302">Support & Security</h2>
        <Card className="mb-4" data-id="element-303">
          <div className="flex items-center py-2" data-id="element-304">
            <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-305">
              <div size={18} className="text-blue-600" data-id="element-306" />
            </div>
            <span data-id="element-307">Help & Support</span>
            <div className="ml-auto" data-id="element-308">
              <div className="text-blue-600" data-id="element-309">Contact</div>
            </div>
          </div>
          <div className="flex items-center py-2 border-t" data-id="element-310">
            <div className="p-2 bg-green-100 rounded-full mr-3" data-id="element-311">
              <ShieldIcon size={18} className="text-green-600" data-id="element-312" />
            </div>
            <span data-id="element-313">Privacy & Security</span>
            <div className="ml-auto" data-id="element-314">
              <div className="text-blue-600" data-id="element-315">View</div>
            </div>
          </div>
        </Card>
        <Button variant="outline" fullWidth className="mt-6 text-red-600 border-red-200 hover:bg-red-50" icon={<LogOutIcon size={18} data-id="element-317" />} data-id="element-316">
          Sign Out
        </Button>
      </div>
    </div>;
}